import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Button from "../Button";

import "./_style.scss";

const ButtonGroup = ({
  buttons,
  value,
  onChange,
  look,
  isRounded,
  ...other
}) => (
  <div
    className={
        classNames(
          "button-group",
          other.className,
          {
            [`--${look}`]: look,
            "--rounded": isRounded,
          },
        )
      }
  >
    {buttons.map((buttonData) => (
      <Button
        className={`button-group__button-element ${buttonData.classes}`}
        onClick={onChange}
        key={buttonData.value}
        value={buttonData.value}
        name={buttonData.name}
        data-test={`button-group-${buttonData.text}`}
        isSelected={value === buttonData.value}
      >
        {buttonData.text}
      </Button>
    ))}
  </div>
);

ButtonGroup.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  onChange: PropTypes.func,
  look: PropTypes.string,
  value: PropTypes.string,
  isRounded: PropTypes.bool,
};

export default ButtonGroup;
